import React from "react";
import styled, { createGlobalStyle } from "styled-components";

export const StyledWrapper = styled.div`
  display: grid;
  justify-content: center;
`

export const StyledActionButtons = styled.div`
  display: grid;
  grid-column-gap: 4rem;
  grid-template-areas: "back next";
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding-top: 2rem;

  @media (max-width: 800px) {
    grid-row-gap: 1rem;
    grid-template-areas:
      "next"
      "back";
    grid-template-columns: minmax(0, 1fr);
  }

  .next {
    grid-area: next
  }

  .back {
    grid-area: back
  }
`

export const StyledDiv = styled.div`
  display: grid;
  grid-row-gap: 1.25rem;
  width: 800px;

  @media (max-width: 800px) {
    width: auto;
  }

  .field-row {
    display: grid;
    &.up-2 {
      grid-column-gap: 4rem;
      grid-template-columns: repeat(2, minmax(0, 1fr));

      @media (max-width: 800px) {
        grid-row-gap: 1.25rem;
        grid-template-columns: minmax(0, 1fr)
      }
    }

    &.up-3 {
      grid-column-gap: 4rem;
      grid-template-columns: repeat(3, minmax(0, 1fr));

      @media (max-width: 800px) {
        grid-row-gap: 1.25rem;
        grid-template-columns: minmax(0, 1fr)
      }

      &.large-small-small {
        grid-template-columns: 1.25fr repeat(2,minmax(0,.5fr));

        @media (max-width: 800px) {
          grid-row-gap: 1.25rem;
          grid-template-columns: minmax(0, 1fr)
        }
      }
    }
  }

  .error-text-clinical {
    color: #bf1e2d;
    font-size: 1rem;
    font-family: 'Whitney Medium';
    font-weight: 500;
    margin: -1.25rem 0 .5rem 0;
  }

  .forward-to-advisor-text {
    color: #019446;
    font-size: 1rem;
    font-family: 'Whitney Medium';
    font-weight: 500;
    margin: -1.25rem 0 .5rem 0;
  }
`
